'use strict';

require('jquery-ui/ui/widgets/autocomplete');

let Radio = require('backbone.radio');
let StepView = require('./step').default;
let maps = require('../../utilities/maps').default;
let polyglot = require('../../utilities/polyglot').default;
let _ = require('underscore');
let $ = require('jquery');
let TitleView = require('../step-title').default;
let ToggleView = require('../locations/toggle').default;
let SearchView = require('../locations/search').default;
let LocationListView = require('../locations/list').default;
let LocationMessageView = require('../locations/message').default;
let MapView = require('../locations/map').default;
let DetailsView = require('../locations/details').default;
let LoadingView = require('../loading').default;
let MessageView = require('../message').default;
let ToastView = require('../toast').default;
let LocationDetailsTemplate = require('./templates/locationDetails.hbs');
let LocationsTemplate = require('./templates/location.hbs');
let LocationDetailsTitleView = require('../location-details-title').default;
let urlHelpers = require('../../utilities/urls').default;
let WaitTimeCollection = require('../../collections/wait-times').default;
let LanguagesCollection = require('../../collections/languages').default;

export default StepView.extend({

  active_search: false,
  showingLocationDetails: false,
  fromMapView: false,

  className: 'l-location-step',

  childViewEvents: {
    'toggle': 'onToggle',
    'search': 'onSearch',
    'search-suggest': 'onSearchSuggest',
    'message-updated': 'onMessageUpdated',
    'search-by-location': 'onSearchByLocation',
    'geolocation-success': 'onGeoLocationSuccess',
    'geolocation-error': 'onGeoLocationError',
    'change:location': 'onChangeLocation',
    'showLocationDetails': 'onShowLocationDetails',
    'load-location-list': 'onLoadLocationList',
    'renderLocationCountMessage': 'onRenderLocationCountMessage',
    'dismissError': 'onDismissError',
  },

  events: {
    'click .l-location-step-map': 'onClickMap',
  },

  ui: {
    search: '.l-location-step-search',
    message: '.l-location-step-message',
    list: '.l-location-step-list',
    error: '.l-location-step-error',
    details: '.l-location-details',
  },

  regions: function() {
    return {
      title: '.' + this.className + '-title',
      toggle: '.' + this.className + '-toggle',
      search: '.' + this.className + '-search',
      message: '.' + this.className + '-message',
      list: '.' + this.className + '-list',
      map: '.' + this.className + '-map',
      locationDetails: '.l-location-details',
      locationDetailsTitle: '.l-location-details-title',
    };
  },

  initialize: function(options) {
    this.fetchWaitTimes = this.fetchWaitTimes.bind(this);
    this.markers = options.markers;
    this.waitTimeCollection = new WaitTimeCollection();
    this.createViews();
    let firstStep = Radio.channel('steps')
      .request('first', polyglot.t('pages.locations.slug'));
    let previousPage = Radio.channel('steps')
      .request('previousSlug');
    this.languages = new LanguagesCollection(window.LANGUAGES);

    if (firstStep) {
      this.showCookieMessage();
      this.fetchWaitTimes(this.collection);
    } else if (!window.SETTINGS.searching_regional_grouping) {
      this.loadingView = new LoadingView();
      this.loadingView.show();
      let data = {
        preferred_service_id: this.appointment.get('service_id'),
        initial_load: true,
      };

      if (window.STAFF && this.appointment.get('staff_id')) {
        data.preferred_staff_id = this.appointment.get('staff_id');
      }

      let preferred_location = this.appointment.getPreferredLocation();
      if (preferred_location) {
        data.lat = preferred_location.get('latitude');
        data.lng = preferred_location.get('longitude');
        data.within = 50;
      }

      data.lang = this.languages.getCurrent();

      let self = this;
      if (previousPage === polyglot.t('pages.times.slug')) {
        this.collection.fetch({
          data: data,
          remove: false,
          success: (response) => {
            this.loadingView.hide();
            this.fetchWaitTimes(response);
          },
          error: function() {
            self.loadingView.hide();
          },
        });
      } else if (previousPage === polyglot.t('pages.services.slug')) {
        this.unsetLocation();
        this.mapView.setLocation(null);
        if (this.appointment.get('service_id') !== data.preferred_service_id) {
          data.preferred_service_id = this.appointment.get('service_id');
        }
        this.collection.fetch({
          data: data,
          reset: true,
          success: (response) => {
            this.fetchWaitTimes(response);
            this.loadingView.hide();
          },
          error: function() {
            self.loadingView.hide();
          },
        });
      }
    }

    this.listenTo(Radio.channel('steps'), 'click:back', this.resetLocationSearch);

    let mediaQueryList = window.matchMedia(
      '(orientation: landscape) '
      + 'and (min-width: 700px)',
    );
    mediaQueryList.addListener(this.handleOrientationChange.bind(this));
  },

  onClickMap: function () {
    $('.location-search-box').blur();
  },

  handleOrientationChange: function(event) {
    if (event.matches) {
      $('.location-map').css('visibility', 'visible');
      $('.l-location-step-search-and-list').show();
    }
    this.calculateListHeight();
  },

  createViews: function() {
    this.titleView = new TitleView({
      title: polyglot.t('pages.locations.long_title'),
    });
    this.toggleView = new ToggleView(this.fromMapView);
    this.searchView = new SearchView();
    this.listView = new LocationListView({
      appointment: this.appointment,
      collection: this.collection,
      waitTimes: this.waitTimeCollection,
    });
    this.listenTo(this.listView, 'change:location', this.onChangeLocation);

    this.messageView = new LocationMessageView({
      collection: this.collection,
    });

    let markers = this.markers;
    let serviceCheck = this.appointment.get('service_id');
    if (serviceCheck.length !== 0) {
      markers = markers.filterByServiceId(serviceCheck);
      if (serviceCheck.length !== 1) {
        if (!markers.sameServices(serviceCheck)) {
          Radio.channel('toast').trigger('show', new ToastView({
            message: polyglot.t('service.not_available_at_all_listed_locations')
          }));
        }
      }
    }
    this.mapView = new MapView({
      appointment: this.appointment,
      collection: this.collection,
      markers: markers,
      fetchWaitTimes: this.fetchWaitTimes,
      waitTimes: this.waitTimeCollection,
      shouldShowWaitTime: this.shouldShowWaitTime(),
    });
  },

  isMobile: function() {
    return this.toggleView.isVisible();
  },

  onRender: function() {
    if (this.showingLocationDetails) {
      this.renderLocationDetails();
    } else {
      this.renderLocationList(this.mapView);
    }
  },

  onDomRefresh: function() {
    if (this.appointment.hasPreferredLocation()) {
      this.showPreferredLocationMessage();
    }
    if (!this.showingLocationDetails) {
      this.mapView.renderMap();
    }
    this.searchView.focus();
    this.calculateListHeight();
  },

  onMessageUpdated: function() {
    this.calculateListHeight();
  },

  calculateListHeight: function() {
    if (this.isMobile()) {
      let nextButtonHeight = $('.l-buttons-right-button').outerHeight();
      let errorHeight = this.ui.error.outerHeight(true);
      let height = nextButtonHeight + errorHeight;
      this.ui.list.height('calc(100% - ' + height + 'px)');
    } else {
      this.calculateListMargin();
      let height = this.ui.error.outerHeight(true)
                   + this.ui.search.outerHeight()
                   + this.ui.message.outerHeight(true)
                   + (this.ui.list.outerHeight(true)
                      - this.ui.list.outerHeight());

      this.ui.list.height('calc(100% - ' + height + 'px)');
    }
  },

  calculateListMargin: function() {
    let listMarginTop = this.ui.search.outerHeight(true);
    $('.l-location-step-search-and-list').css('margin-top', listMarginTop);
  },

  onLoadLocationList: function() {
    this.showingLocationDetails = false;
    this.render();
  },

  onToggle: function(name) {
    if (name == 'Map') {
      this.mapView.refreshMap();
    }
  },

  onSearch: function(q) {
    this.unsetLocation();
    this.messageView.onSearch();
    if (!q.length) {
      if (!this.active_search) {
        return;
      }

      this.active_search = false;
      this.collection.reset(window.LOCATIONS);
      this.messageView.render();
    } else {
      const geocoder = new maps.Geocoder();
      const self = this;

      geocoder.geocode({'address': q}, function(results, status) {
        self.active_search = true;

        if (status !== maps.GeocoderStatus.OK) {
          self.collection.reset();
          return;
        }

        const urlParam = urlHelpers.getParam('within');
        const service = self.appointment.get('service_id');
        const staff = self.appointment.get('staff_id');
        const location = results[0].geometry.location;
        const data = {
          lat: location.lat(),
          lng: location.lng(),
        };

        if (urlParam) {
          data.within = urlParam;
        }

        if (service) {
          data.preferred_service_id = service;
        }

        if (staff) {
          data.preferred_staff_id = staff;
        }

        data.lang = self.languages.getCurrent();

        self.collection.setPosition(location.lat(), location.lng());

        self.collection.fetch({
          data: data,
          reset: true,
          success: (response) => {
            self.messageView.render();
            self.mapView.removeDots();
            $('#location-search').blur();
            self.fetchWaitTimes(response);
          },
        });

        self.collection.sort();

        self.mapView.setCenter(location.lat(), location.lng());
      });
    }
  },

  onSearchByLocation: function() {
    this.mapView.onSearchByLocation();
  },

  onSearchSuggest: function(input) {
    const self = this;

    $('#location-search').autocomplete({
      minLength: 3,
      source: (request, response) => {
        const params = { 'filter[query]': input, language: $('html').attr('lang') };

        $.get('/online_bookings/locations/suggestions', params, (data) => {
          response(data.data.map(suggestion => suggestion.attributes.name));
        });
      },
      select: (event, object) => {
        return self.onSearch(object.item.value);
      },
    });
  },

  onGeoLocationSuccess: function() {
    this.searchView.onGeoLocationSuccess();
    this.calculateListHeight();
  },

  onGeoLocationError: function() {
    this.searchView.onGeoLocationError();
    this.calculateListHeight();
  },

  onChangeLocation: function(location) {
    if (location) {
      let prevLocation = this.appointment.getLocation();
      if ((prevLocation && location.get('id') !== prevLocation.get('id')) ||
          !prevLocation) {
        window.localStorage.removeItem('timezone', {path: '/'});
      }

      this.setLocation(location);
      if (!window.SERVICE && Radio.channel('steps')
                                  .request('first',
                                      polyglot.t('pages.locations.slug'))) {
        this.appointment.unsetServices();
      }
      if (!window.STAFF) {
        this.appointment.unsetStaff();
      }
    } else {
      this.unsetLocation();
    }
  },

  onShowLocationDetails: function(location) {
    if (location) {
      let prevLocation = this.appointment.getLocation();
      if ((prevLocation && location.get('id') !== prevLocation.get('id')) ||
          !prevLocation) {
        window.localStorage.removeItem('timezone', {path: '/'});
      }

      this.setLocation(location);
      if (!window.SERVICE && Radio.channel('steps')
                                  .request('first',
                                      polyglot.t('pages.locations.slug'))) {
        this.appointment.unsetServices();
      }
      if (!window.STAFF) {
        this.appointment.unsetStaff();
      }

      this.fromMapView = location.fromMapView;

      if (this.isMobile()) {
        this.openDetails();
      }
    } else {
      this.unsetLocation();
    }
  },

  onDismissError: function () {
    this.calculateListHeight();
  },

  setLocation: function(location) {
    this.appointment.setLocation(location);
    this.listView.setLocation(location);

    if (!this.isMobile()) {
      this.mapView.setLocation(location);
    }
  },

  unsetLocation: function() {
    this.appointment.unsetLocation();
    if (!window.SERVICE && Radio.channel('steps').request('first', polyglot.t('pages.locations.slug'))) {
      this.appointment.unsetServices();
    }
    this.resetLocationSearch(false);
  },

  resetLocationSearch: function(reset) {
    reset = typeof reset !== 'undefined' ? reset : true;
    this.listView.setLocation(null);
    if (!this.isMobile()) {
      this.mapView.setLocation(null);
    }
    if (reset) {
      this.collection.reset();
    }
  },

  setCollection: function(collection) {
    this.listView.collection = collection;
    this.listView.render();
    this.mapView.collection = collection;
    this.mapView.render();
  },

  openDetails: function(fromMapView) {
    this.showingLocationDetails = true;
    if (fromMapView) {
      this.fromMapView = true;
    }
    this.render();
  },

  getTemplate: function() {
    if (this.showingLocationDetails) {
      return LocationDetailsTemplate;
    } else {
      return LocationsTemplate;
    }
  },

  showPreferredLocationMessage: function() {
    Radio.channel('modal').trigger('show', new MessageView({
      message: polyglot.t('location.selected_location_does_not_perform')
    }));
  },

  renderLocationList: function() {
    this.createViews();

    this.getRegion('title').show(this.titleView);
    this.getRegion('toggle').show(this.toggleView);
    this.getRegion('search').show(this.searchView);
    this.getRegion('list').show(this.listView);
    this.getRegion('message').show(this.messageView);
    this.getRegion('map').show(this.mapView);

    if (this.appointment.hasLocation()) {
      this.setLocation(this.appointment.getLocation());
    } else if (this.collection.length === 1) {
      this.setLocation(this.collection.at(0));
    }
  },

  renderLocationDetails: function() {
    this.detailsView = new DetailsView({
      model: this.appointment.getLocation(),
      latitude: this.collection.latitude,
      longitude: this.collection.longitude,
      waitTimes: this.waitTimeCollection,
      shouldShowWaitTime: this.shouldShowWaitTime(),
    });
    this.locationDetailsTitleView = new LocationDetailsTitleView({
      title: polyglot.t('pages.locationDetails.title'),
      fromMapView: this.fromMapView,
    });

    this.getRegion('locationDetailsTitle').show(this.locationDetailsTitleView);
    this.getRegion('locationDetails').show(this.detailsView);
    this.calculateLocationDetailsHeight();
  },

  calculateLocationDetailsHeight: function() {
    let nextButtonHeight = $('.l-buttons-right-button').outerHeight();
    this.ui.details.height('calc(100% - ' + nextButtonHeight + 'px)');
  },

  onRenderLocationCountMessage: function() {
    this.messageView.render();
  },

  isWaitTimeEnabled: function () {
    return window.SETTINGS.show_wait_time;
  },

  shouldShowWaitTime: function () {
    return this.isWaitTimeEnabled()
      && this.appointment.isDisplayInLobbyEnabled()
      && this.appointment.get('service_id').length === 1
      && !this.appointment.get('staff_id');
  },

  fetchWaitTimes: function (collection) {
    if (this.shouldShowWaitTime()) {
      this.waitTimeCollection.fetch({
        data: {
          service: this.appointment.get('service_id')[0],
          locations: this.extractLocationIds(collection),
          lang: $('html').attr('lang'),
        },
        reset: true,
        success: () => {
          if (this.showingLocationDetails) {
            this.renderLocationDetails();
          } else {
            this.listView.render();
          }
        },
      });
    }
  },

  extractLocationIds: function (collection) {
    return collection.models
      .filter(model => model.shouldShowWaitTime())
      .map(model => model.id);
  },
});
